import Component from './InDmCardButton.vue'
export default Component
export * from './types'
